"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  "AP": [{
    "link": "https://www.concur.com.au",
    "rank": "0",
    "name": "Australia (English)",
    "country": "AU"
  }, {
    "link": "https://www.concur.cn",
    "rank": "1",
    "name": "中国（简体中文)",
    "country": "CN"
  }, {
    "link": "https://www.concur.com.hk",
    "rank": "3",
    "name": "Hong Kong SAR of China (English)",
    "country": "HK"
  }, {
    "link": "https://www.concur.co.in",
    "rank": "4",
    "name": "India (English)",
    "country": "IN"
  }, {
    "link": "https://www.concur.co.jp",
    "rank": "5",
    "name": "日本（日本語）",
    "country": "JP"
  }, {
    "link": "https://www.concur.kr",
    "rank": "6",
    "name": "대한민국(한국어)",
    "country": "KR"
  }, {
    "link": "https://www.concur.com.sg",
    "rank": "7",
    "name": "Singapore (English)",
    "country": "SG"
  }, {
    "link": "https://www.concur.tw",
    "rank": "8",
    "name": "中國台灣(繁體中文)",
    "country": "TW"
  }],
  "AM": [{
    "link": "https://www.concur.com",
    "rank": "0",
    "name": "United States (English)",
    "country": "US"
  }, {
    "link": "https://www.concur.ca",
    "rank": "1",
    "name": "Canada (English)",
    "country": "CA"
  }, {
    "link": "https://www.concur.ca/fr",
    "rank": "2",
    "name": "Canada (Français)",
    "country": "CAFR"
  }, {
    "link": "https://www.concur.com.mx",
    "rank": "0",
    "name": "México (Español)",
    "country": "MX"
  }, {
    "link": "https://www.concur.com.br",
    "rank": "1",
    "name": "Brasil (Português)",
    "country": "BR"
  }, {
    "link": "https://www.concur.com.ar",
    "rank": "5",
    "name": "Argentina (Español)",
    "country": "AR"
  }, {
    "link": "https://www.concur.co",
    "rank": "6",
    "name": "Columbia (Español)",
    "country": "CO"
  }, {
    "link": "https://www.concur.cl",
    "rank": "7",
    "name": "Chile (Español)",
    "country": "CL"
  }, {
    "link": "https://www.concur.pe",
    "rank": "8",
    "name": "Peru (Español)",
    "country": "PE"
  }],
  "EU": [{
    "link": "https://www.concur.co.uk",
    "rank": "0",
    "name": "United Kingdom (English)",
    "country": "UK"
  }, {
    "link": "https://www.concur.fr",
    "rank": "1",
    "name": "France (Français)",
    "country": "FR"
  }, {
    "link": "https://www.concur.de",
    "rank": "2",
    "name": "Deutschland (Deutsch)",
    "country": "DE"
  }, {
    "link": "https://www.concur.it",
    "rank": "3",
    "name": "Italia (Italiano)",
    "country": "IT"
  }, {
    "link": "https://www.concur.nl",
    "rank": "5",
    "name": "Nederlands (English)",
    "country": "NL"
  }, {
    "link": "https://www.concur.se",
    "rank": "6",
    "name": "Sweden (English)",
    "country": "SE"
  }, {
    "link": "https://www.concur.dk",
    "rank": "7",
    "name": "Denmark (English)",
    "country": "DK"
  }, {
    "link": "https://www.concur.fi",
    "rank": "8",
    "name": "Finland (English)",
    "country": "FI"
  }, {
    "link": "https://www.concur.be",
    "rank": "9",
    "name": "Belgium (English)",
    "country": "BE"
  }, {
    "link": "https://www.concur.es",
    "rank": "10",
    "name": "España (Español)",
    "country": "ES"
  }, {
    "link": "https://www.concur.no",
    "rank": "11",
    "name": "Norway (English)",
    "country": "NO"
  }],
  "MEA": [{
    "link": "https://www.concur.co.za",
    "rank": "0",
    "name": "South Africa (English)",
    "country": "ZA"
  }, {
    "link": "https://www.concur.ae",
    "rank": "1",
    "name": "United Arab Emirates (English)",
    "country": "AE"
  }],
  "regionTranslation": {
    "AM": "Americas",
    "MEA": "Middle East and Africa",
    "EU": "Europe",
    "AP": "Asia Pacific"
  }
};